
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';


import { ServiceBase } from '@app/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Area } from '@app/models/area';
import { log } from 'console';

@Injectable()
export class AreaService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }
  gravar(area: Area): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'configuracoes/area', area).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `configuracoes/area/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/area/${id}`);
  }

  obterLista(descricao: string, pagina: number): Observable<Area[]> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `configuracoes/area/lista/`, { headers: { meta: ['search'] }});
  }

}
